import React from 'react';
import { IconTextButton } from 'ui-lib';
import deviceCss from './device-attributes.css';
import { useInteractiveAttribute } from './use-interactive-attribute';
import { DeviceInfosStore } from 'store/device-details/device-info-store';
import { DeviceAttributeName } from 'dto/device-dto';
import { ITextFieldValidation, TextAttributeItem } from './text-attribute-item';
import { observer } from 'mobx-react';

interface IInteractiveSubcard {
    deviceInfosStore: DeviceInfosStore;
    title: string;
    attributeName: DeviceAttributeName;
    initialValue: string;
    form?: any;
}

export const InteractiveSubcardTextFieldItem = observer((props: IInteractiveSubcard): React.ReactElement => {
    const { attributeName, title, initialValue, deviceInfosStore, form } = props;
    const [textFieldValidation, setTextFieldValidation] = React.useState<ITextFieldValidation>({
        status: 'success',
    });

    const { editing, hasPermission, attributeValue, toggleEdit, onSaveAttribute, onUpdateAttribute } = useInteractiveAttribute({
        attributeName,
        deviceInfosStore,
        initialAttributeValue: initialValue,
        onDestroy: () => {
            form?.resetFields([attributeName]);
            setTextFieldValidation({ status: 'success' });
        },
    });

    return (
        <div key={attributeName} className={deviceCss['sub-card']}>
            <h3>
                <span className={deviceCss['sub-card-title']}>{title}</span>
                <IconTextButton
                    key={`${attributeName}-action`}
                    className={deviceCss.editBtn}
                    onClick={toggleEdit}
                    hidden={!hasPermission}
                    iconName='edit'
                />
            </h3>
            {editing ? (
                <TextAttributeItem
                    attributeName={attributeName}
                    attributeValue={attributeValue}
                    textFieldValidation={textFieldValidation}
                    onChange={(values): void => {
                        setTextFieldValidation({ status: 'success' });
                        onUpdateAttribute(values.target.value);
                    }}
                    onSaveAttribute={onSaveAttribute}
                />
            ) : (
                <span key={`span-${attributeName}`}>{attributeValue}</span>
            )}
        </div>
    );
});